class MFRProductStickyBar {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            firstSection : "main .shopify-section:first-child"
        } 

        this.init();
    }

    init() {
        if( !gsap || !ScrollTrigger || !ScrollTrigger.create ) return;

        this.$firstSection = $( this.selectors.firstSection );

        this.initScrollTrigger();
    }

    initScrollTrigger() {
        ScrollTrigger.create({
          trigger: this.$firstSection,
          start: "30% top",
          endTrigger: "html",
          end: "bottom top",
          onToggle: self => {
            this.$element.toggleClass( "is-active", self.isActive );
          }
        });
    }
}